<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">音频播报</span>
      </div>
    </div>
    <div class="box1"
         v-if="tabIndex == 1">
      <div class="b1top">
        <div class="b1tl">
          <span @click="b1Index = 1"
                :style="b1Index == 1 ? 'color: #0B8586;' : ''">历史音频资源</span>
          <span @click="b1Index = 2"
                :style="b1Index == 2 ? 'color: #0B8586;' : ''">草稿箱（{{ draftNum }}）</span>
        </div>
        <div class="b1tr"
             @click="IsAddResources = true"
             style="cursor:pointer">
          <img src="../../assets/img/icon/jia2.png"
               alt="" />
          <span style="margin-right:0">新增</span>
        </div>
      </div>
      <div class="listbox">
        <table v-if="b1Index == 1">
          <thead>
            <tr>
              <th>音频封面</th>
              <th>音频标题</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in storeList"
                :key="index">
              <td>
                <img :src="item.audioCoverResUrl"
                     style="width:65px;height:45px;margin:15px"
                     alt="" />
              </td>
              <td>{{ item.title }}</td>
              <td>
                <img style="margin-right:10px;cursor: pointer;"
                     src="../../assets/img/icon/bofang.png"
                     @click="toShow(item)"
                     alt="" />
                <img style="margin-right:10px;cursor: pointer;"
                     src="../../assets/img/icon/bianji.png"
                     @click="toUpdataResources(item.id)"
                     alt="" />
                <img src="../../assets/img/icon/shanchu.png"
                     style="cursor: pointer;"
                     v-show="item.audit != 9"
                     @click="toDeleteResources(item.id)"
                     alt="" />
              </td>
            </tr>
            <tr v-show="storeList.length < 1">
              <td colspan="3">暂无资源信息</td>
            </tr>
          </tbody>
        </table>
        <table v-if="b1Index == 2">
          <thead>
            <tr>
              <th>音频封面</th>
              <th>音频标题</th>
              <th style="width:313px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in storeList"
                :key="index">
              <td>
                <img :src="item.audioCoverResUrl"
                     style="width:65px;height:45px;margin:15px"
                     alt="" />
              </td>
              <td>{{ item.title }}</td>
              <td>
                <div style="background:#C32424"
                     @click="toDeleteResources(item.id)"
                     class="b1btn">删除</div>
                <div style="background:#5590E8"
                     @click="toUpdataResources(item.id)"
                     class="b1btn">修改</div>
                <div style="background:#0B8586"
                     @click="toSubmitResources(item.id)"
                     class="b1btn">提交</div>
              </td>
            </tr>
            <tr v-show="storeList.length < 1">
              <td colspan="3">暂无资源信息</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  @page-change="pageChange"></pagination>
      <el-dialog :visible.sync="IsAddResources"
                 class="AddResources"
                 :show-close="false"
                 width="814px">
        <div class="addResTop">
          <span>音频播报标题：</span>
          <input type="text"
                 v-model="resTitle"
                 placeholder="请输入音频标题" />
          <div>
            <span :style="resTitle.length > 30 ? 'color:red' : ''">{{ resTitle.length }}</span>
            <span>/</span>
            <span>30</span>
          </div>
        </div>
        <div class="addResTop2">
          <span>音频上传：</span>
          <webupload fileaccept=".mp3"
                     :Maxfileszie="100"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="handleSuccess"
                     :before-upload="beforeUpload">
            <div>选择资源</div>
          </webupload>
          <span style="color: #0B8586;margin-left:10px">注：仅支持上传1个.mp3格式的文件</span>
        </div>
        <div class="addResList"
             v-show="resInfoName">
          <div>
            <span>{{ resInfoName }}</span>
          </div>
        </div>
        <div class="addResTop2"
             :style="updateing?'margin-top:60px':''">
          <span>封面上传：</span>
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="handleSuccess2"
                     :before-upload="beforeAvatarUpload">
            <div style="width: 173px;height: 28px;background: #fff;border: 1px solid #E5E5E5;color:#000000">
              <img src="../../assets/img/icon/import.png"
                   style="margin-right:10px"
                   alt="" />
              <span>选择文件</span>
            </div>
          </webupload>
          <span style="color: #0B8586;margin-left:10px">注：支持.jpg,.jpeg,.png格式的文件</span>
          <img :src="resImg"
               v-show="resImg"
               style="width:65px;height:45px;margin-left:50px"
               alt="" />
        </div>
        <div class="addResTop">
          <span>排序：</span>
          <input type="text"
                 v-model="resPaixu"
                 placeholder="请输入排序数字" />
        </div>
        <div class="addResTop2">
          <span>简介文字描述：</span>
        </div>
        <div class="addResTop jianjie">
          <input type="text"
                 v-model="resJian"
                 placeholder="请输入文字描述" />
          <div>
            <span :style="resJian.length > 1000 ? 'color:red' : ''">{{ resJian.length }}</span>
            <span>/</span>
            <span>1000</span>
          </div>
        </div>
        <div class="addResTop3">
          <span>注：以上各项均为必填项</span>
        </div>
        <div class="addResTop5">
          <div class="aRT4box"
               @click="submit(1)">提交资源</div>
          <div class="aRT4box"
               @click="submit(4)"
               style="background: #9EA2A2;">存草稿</div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="IsUpdataResources"
                 class="AddResources"
                 :show-close="false"
                 width="814px">
        <div class="addResTop">
          <span>音频标题</span>
          <input type="text"
                 v-model="updataForm.resTitle"
                 placeholder="请输入音频标题" />
          <div>
            <span :style="updataForm.resTitle.length > 30 ? 'color:red' : ''">{{ updataForm.resTitle.length }}</span>
            <span>/</span>
            <span>30</span>
          </div>
        </div>
        <div class="addResTop2">
          <span>音频上传：</span>
          <webupload fileaccept=".mp3"
                     :Maxfileszie="100"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="handleSuccess4"
                     :before-upload="beforeUpload">
            <div>选择资源</div>
          </webupload>
          <span style="color: #0B8586;margin-left:10px">注：仅支持上传mp3格式的文件</span>
        </div>
        <div class="addResList">
          <div>
            <span>{{ updataForm.resInfoName }}</span>
          </div>
        </div>
        <div class="addResTop2">
          <span>封面上传：</span>
          <webupload fileaccept=".jpg,.jpeg,.png"
                     :Maxfileszie="3"
                     :uploadtype="1"
                     :orgid="orgid"
                     :onSuccess="handleSuccess3"
                     :before-upload="beforeAvatarUpload">
            <div style="width: 173px;height: 28px;background: #fff;border: 1px solid #E5E5E5;color:#000000">
              <img src="../../assets/img/icon/import.png"
                   style="margin-right:10px"
                   alt="" />
              <span>选择文件</span>
            </div>
          </webupload>
          <span style="color: #0B8586;margin-left:10px">注：支持.jpg,.jpeg,.png格式的文件</span>
          <img :src="updataForm.resImg"
               v-show="updataForm.resImg"
               style="width:65px;height:45px;margin-left:50px"
               alt="" />
        </div>
        <div class="addResTop">
          <span>排序：</span>
          <input type="text"
                 v-model="updataForm.resPaixu"
                 placeholder="请输入排序数字" />
        </div>
        <div class="addResTop2">
          <span>简介文字描述：</span>
        </div>
        <div class="addResTop jianjie">
          <input type="text"
                 v-model="updataForm.resJian"
                 placeholder="请输入文字描述" />
          <div>
            <span :style="updataForm.resJian.length > 1000 ? 'color:red' : ''">{{ updataForm.resJian.length }}</span>
            <span>/</span>
            <span>1000</span>
          </div>
        </div>
        <div class="addResTop3">
          <span>注：以上各项均为必填项</span>
        </div>
        <div class="addResTop5">
          <div class="aRT4box"
               @click="upSubmit()">提交修改</div>
          <div class="aRT4box"
               @click="quxiao"
               style="background: #9EA2A2;">取消</div>
        </div>
      </el-dialog>
    </div>
    <perview :prerurl="prerurl"
             :show="IsPreview"
             :width="'856px'"
             :title="previewtitle"
             @dialogData="closeDialog"
             :filetype="filetype"></perview>
  </div>
</template>
<script>
import webupload from '../../components/webupload/webupload.vue';
import Perview from '../../components/Preview/Preview-template.vue';
export default {
  name: 'uaBroadcast',
  components: {
    webupload,
    Perview
  },
  data () {
    return {
      storeName: '',
      tabIndex: 1,
      b1Index: 1,
      storeList: [],
      draftNum: 0,
      pageCount: 0,
      pageSize: 6,
      pageIndex: 1,
      IsAddResources: false,
      resTitle: '',
      resJian: '',
      resImg: '',
      resImgId: '',
      resInfoId: '',
      resInfo: '',
      resInfoName: '',
      resPaixu: 0,
      itemId: 0,
      audit: 0,
      IsUpdataResources: false,
      updataForm: {
        resTitle: '',
        resJian: '',
        resImg: '',
        resImgId: '',
        resInfoId: '',
        resInfo: '',
        resInfoName: '',
        resPaixu: 0
      },
      orgid: 0,
      uid: 0,
      state: 0,
      prerurl: '',
      IsPreview: false,
      previewtitle: '',
      filetype: '',
      updateing: false
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName');
    this.orgid = Number(localStorage.getItem('storeId'));
    this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
    this.GetMyStoreList();
    this.GetDraftNum();
  },
  watch: {
    b1Index: function () {
      this.GetMyStoreList();
      this.GetDraftNum();
    }
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    beforeUpload () {
      this.updateing = true
    },
    handleSuccess (response, file) {
      this.updateing = false
      this.resInfoId = response.resid;
      this.resInfo = response.ossfileurl;
      this.resInfoName = file.name;
    },
    handleSuccess2 (response) {
      this.resImgId = response.resid;
      this.resImg = response.ossfileurl;
    },
    handleSuccess3 (response) {
      this.updataForm.resImgId = response.resid;
      this.updataForm.resImg = response.ossfileurl;
    },
    handleSuccess4 (response, file) {
      this.updateing = false
      this.updataForm.resInfoId = response.resid;
      this.updataForm.resInfo = response.ossfileurl;
      this.updataForm.resInfoName = file.name;
    },
    GetMyStoreList () {
      this.httphelper
        .post('/api/EnterpriseApi/GetAudioBroadcastList', {
          type: 1,
          businesId: Number(localStorage.getItem('storeId')),
          state: this.b1Index == 1 ? 1 : 4,
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data;
            this.pageCount = res.data.totalcount;
          }
        });
    },
    GetDraftNum () {
      this.httphelper
        .post('/api/EnterpriseApi/GetAudioBroadcastList', {
          type: 1,
          businesId: Number(localStorage.getItem('storeId')),
          state: 4,
          page: this.pageIndex,
          limit: 99
        })
        .then(res => {
          if (res.data.code == 200) {
            this.draftNum = res.data.totalcount;
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList();
    },
    submit (type) {
      if (this.resTitle == '') return this.$message.warning('请输入音频播报标题');
      if (this.resInfoId == '') return this.$message.warning('请上传音频文件');
      if (this.resImgId == '') return this.$message.warning('请上传封面文件');
      if (this.resJian == '') return this.$message.warning('请输入简介');
      this.httphelper
        .post('/api/EnterpriseApi/SaveAudioBroadcast', {
          id: 0,
          businesId: this.orgid,
          busType: 1,
          title: this.resTitle,
          contentText: this.resJian,
          audioResId: this.resInfoId,
          audioResUrl: this.resInfo,
          audioCoverResId: this.resImgId,
          audioCoverResUrl: this.resImg,
          is_Putaway: true,
          state: type,
          createUserID: this.uid,
          sort: Number(this.resPaixu)
        })
        .then(res => {
          if (res.data.code == 200) {
            if (type == 1) this.$message.success('提交成功');
            else if (type == 4) this.$message.success('存草稿成功');
            this.GetMyStoreList();
            this.GetDraftNum();
            this.resTitle = '';
            this.resJian = '';
            this.resImgId = '';
            this.resInfoId = '';
            this.resImg = '';
            this.resInfoName = '';
            this.resInfo = '';
            this.resPaixu = 0
            this.IsAddResources = false;
          }
        });
    },
    toUpdataResources (id) {
      this.itemId = id;
      this.httphelper
        .post('/api/EnterpriseApi/GetAudioBroadcastInfoByID', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.updataForm.resTitle = res.data.data.title;
            this.updataForm.resJian = res.data.data.contentText;
            this.updataForm.resImgId = res.data.data.audioCoverResId;
            this.updataForm.resInfoId = res.data.data.audioResId;
            this.updataForm.resImg = res.data.data.audioCoverResUrl;
            this.updataForm.resInfoName = res.data.data.audioResName;
            this.updataForm.resPaixu = res.data.data.sort;
            this.state = res.data.data.state;
            this.IsUpdataResources = true;
          }
        });
    },
    toDeleteResources (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.httphelper
            .post('/api/EnterpriseApi/DelAudioBroadcast', {
              id: id
            })
            .then(res => {
              if (res.data.code == 200) {
                this.GetMyStoreList();
                this.GetDraftNum();
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    upSubmit () {
      if (this.updataForm.resTitle == '') return this.$message.warning('请输入音频播报标题');
      if (this.updataForm.resInfoId == '') return this.$message.warning('请上传音频文件');
      if (this.updataForm.resImgId == '') return this.$message.warning('请上传封面文件');
      if (this.updataForm.resJian == '') return this.$message.warning('请输入简介');
      this.httphelper
        .post('/api/EnterpriseApi/SaveAudioBroadcast', {
          id: this.itemId,
          businesId: this.orgid,
          busType: 1,
          title: this.updataForm.resTitle,
          contentText: this.updataForm.resJian,
          audioResId: this.updataForm.resInfoId,
          audioResUrl: this.updataForm.resInfo,
          audioCoverResId: this.updataForm.resImgId,
          audioCoverResUrl: this.updataForm.resImg,
          is_Putaway: true,
          state: this.state,
          createUserID: this.uid,
          sort: Number(this.updataForm.resPaixu)
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('保存成功');
            this.GetMyStoreList();
            this.GetDraftNum();
            this.updataForm.resTitle = '';
            this.updataForm.resJian = '';
            this.updataForm.resImgId = '';
            this.updataForm.resInfoId = '';
            this.updataForm.resImg = '';
            this.updataForm.resInfoName = '';
            this.updataForm.resInfo = '';
            this.updataForm.resPaixu = 0;
            this.IsUpdataResources = false;
          }
        });
    },
    toSubmitResources (id) {
      this.itemId = id;
      this.httphelper
        .post('/api/EnterpriseApi/GetAudioBroadcastInfoByID', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.updataForm.resTitle = res.data.data.title;
            this.updataForm.resJian = res.data.data.contentText;
            this.updataForm.resImgId = res.data.data.audioCoverResId;
            this.updataForm.resInfoId = res.data.data.audioResId;
            this.updataForm.resImg = res.data.data.audioCoverResUrl;
            this.updataForm.resInfoName = res.data.data.audioResName;
            this.httphelper
              .post('/api/EnterpriseApi/SaveAudioBroadcast', {
                id: id,
                businesId: this.orgid,
                busType: 1,
                title: this.updataForm.resTitle,
                contentText: this.updataForm.resJian,
                audioResId: this.updataForm.resInfoId,
                audioResUrl: this.updataForm.resInfo,
                audioCoverResId: this.updataForm.resImgId,
                audioCoverResUrl: this.updataForm.resImg,
                is_Putaway: true,
                state: 1,
                createUserID: this.uid
              })
              .then(res => {
                if (res.data.code == 200) {
                  this.$message.success('提交成功');
                  this.GetMyStoreList();
                  this.GetDraftNum();
                  this.updataForm.resTitle = '';
                  this.updataForm.resJian = '';
                  this.updataForm.resImgId = '';
                  this.updataForm.resInfoId = '';
                  this.updataForm.resImg = '';
                  this.updataForm.resInfoName = '';
                  this.updataForm.resInfo = '';
                }
              });
          }
        });
    },
    quxiao () {
      this.resTitle = '';
      this.resJian = '';
      this.resImgId = '';
      this.resInfoId = '';
      this.resImg = '';
      this.resInfoName = '';
      this.resInfo = '';
      this.IsUpdataResources = false;
    },
    toShow (item) {
      this.prerurl = item.audioResUrl;
      this.previewtitle = item.contentText;
      this.filetype = '.mp3';
      this.IsPreview = true;
    },
    closeDialog () {
      this.IsPreview = false;
    }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
    padding-left: 17px;
    margin: 30px 0 40px 0;
}
.box1 {
    padding-top: 10px;
}
.b1top {
    margin: 20px 0;
    height: 18px;
    line-height: 18px;
    padding-left: 14px;
    border-left: 2px solid #0b8586;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.b1top span {
    margin-right: 40px;
    cursor: pointer;
}
.b1tr {
    display: flex;
    align-items: center;
}
.b1tr img {
    margin-right: 10px;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.b1btn {
    width: 70px;
    height: 30px;
    border-radius: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
}
.b1fengmian {
    width: 65px;
    height: 45px;
}
.box2 {
    padding-top: 20px;
}
.AddResources ::v-deep .el-dialog__header {
    display: none;
}
.AddResources ::v-deep .el-dialog__body {
    padding: 35px 50px;
    box-sizing: border-box;
}
.addResTop {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;
}
.addResTop input {
    flex: 1;
    margin: 0 10px;
    border: none;
    outline: none;
}
.addResTop2 {
    min-height: 30px;
    margin-top: 26px;
    display: flex;
    align-items: center;
}
.addResList {
    margin-top: 26px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.addResList div {
    display: flex;
    align-items: center;
    height: 30px;
}
.addResTop2 div {
    width: 175px;
    height: 30px;
    background: #0b8586;
    border-radius: 3px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}
.addResTop2 .jgbox {
    width: 173px;
    height: 28px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    background-color: #fff;
    display: flex;
    align-items: center;
}
.addResTop2 input {
    width: 159px;
    height: 24px;
    border: none;
    outline: none;
    padding-left: 10px;
}
.jianjie input {
    margin-left: 0;
}
.addResTop3 {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
}
.addResTop5 {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
}
.aRT4box {
    width: 148px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    margin: 0 5px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.addResTop ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #0b8586 !important;
}
.addResTop ::v-deep .el-radio__input.is-checked .el-radio__inner {
    background: #0b8586 !important;
    border-color: #0b8586 !important;
}
.pagination_Wrap {
    margin-bottom: 0;
}
</style>
